import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../config';
import '../assets/css/marketing.css';

const Marketing: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter a valid email');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${config.apiBaseUrl}/marketing-signup/`, { email });
      if (response.data.success) {
        toast.success('Thanks for signing up for free trial');
        setEmail('');
      } else {
        const msg = response.data.message || 'Something went wrong. Please try again.';
        toast.error(msg);
      }
    } catch (error: any) {
      const msg = error?.response?.data?.error || 'Something went wrong. Please try again.';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="marketing-page">
      <main>
        <div className="marketing-card">
          <h1 className="marketing-title">Sign Up Now</h1>
          <p>
            For a Chance to Win Accuprice <span className="highlight">FREE</span> for a Year
          </p>
          <form onSubmit={handleSubmit} className="marketing-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="marketing-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="marketing-button"
            >
              {loading ? 'Submitting...' : 'Sign Up'}
            </button>
          </form>
        </div>
      </main>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default Marketing; 